import React, { useEffect, useState } from 'react';
import { Menu, Layout } from 'antd';
import {
  getMenuFromPath,
  useRestaurantNavItems,
  useSystemNavItems,
} from './constants';
import { useLocation } from 'react-router-dom';
import UserInfo from './components/UserInfo';

const { Sider } = Layout;

const Sidebar = () => {
  const { root, key } = getMenuFromPath(useLocation().pathname);
  const [open, setOpen] = useState<string[]>([root]);
  const systemNavItems = useSystemNavItems();
  const restaurantNavItems = useRestaurantNavItems();

  useEffect(() => {
    setOpen([root]);
  }, [root]);

  return (
    <Sider theme="light" width={240} breakpoint="lg" collapsedWidth="0">
      <div className="flex flex-col min-h-screen pb-4">
        <div className="w-full">
          <UserInfo />
          <Menu
            mode="inline"
            openKeys={open}
            selectedKeys={[key]}
            items={systemNavItems}
            onOpenChange={(keys) => setOpen(keys)}
          />
        </div>
        <div className="w-full mt-2">
          <p className="ml-4 mb-2 font-semibold text-neutral-400">
            Restaurant-Level
          </p>
          <Menu
            mode="inline"
            openKeys={open}
            selectedKeys={[key]}
            items={restaurantNavItems}
            onOpenChange={(keys) => setOpen(keys)}
          />
        </div>
      </div>
    </Sider>
  );
};

export default Sidebar;
